import { Auditable, FormSelectCategory, FormSelectOption, QueryParams, SortParams } from "../..";

export interface FormSelect extends Auditable {
    formSelectCategoryId?: number;
    slug: string;
    name: string;
    description?: string;
    formSelectOptions?: FormSelectOption[];
    formSelectCategory?: FormSelectCategory;
}

export const DefaultFormSelectQueryParams: QueryParams = {
    description: "",
    name: "",
};

export const DefaultFormSelectSortParams: SortParams = {
    orderBy: "name",
    orderDesc: "false",
};
